export default {
    database: {
        BasicInfo: '基础信息',
        DatabaseType: '数据库类型',
        RemoteDatabase: '远程数据库',
        BuiltInDatabase: '内置数据库',
        DatabaseName: '数据库名称',
        DatabaseDescription: '数据库描述',
        PermissionManagement: '权限管理',
        PermissionSettings: '权限设置',
        Query: '查询',
        Add: '新增',
        Edit: '编辑',
        Delete: '删除',
        ConnectionInfo: '连接信息',
        Port: '端口',
        Username: '用户名',
        DatabaseNameLabel: '数据库名',

        DeleteDatabase: '删除数据库',
        ConfirmDelete: '删除将无法恢复此数据库，是否确认删除?',
        DeleteSuccess: '删除成功',
        ModifySuccess: '修改成功',
        DatabaseTypeLabel: '数据库类型',
        Host: '主机',


        DatabaseLabel: '数据库',
        DeletingDatabase: '数据库删除中，请稍后~',
        PleaseEnterDatabaseName: '请输入数据库名称',
        PleaseEnterDatabaseDescription: '请输入数据库描述',
        PleaseEnterDatabase: '请填写数据库',
        PleaseEnterHost: '请填写主机',
        PleaseEnterPort: '请填写端口',
        PleaseEnterUsername: '请填写用户名',
        PleaseEnterPassword: '请填写密码',
        PleaseSelectDatabaseType: '请选择数据库类型',
        PleaseSelectPermission: '请至少选择一个权限',
        ModifyingDatabase: '修改中...',
        ModifyDatabaseInfo: '修改数据库信息',
        DatabaseNameRequired: '数据库名称不能为空',
        DatabaseDescriptionTip: '数据库的描述将用于数据库的决策，请尽量清楚地描述数据库内容及使用场景',
        PermissionSettingsTip: '能够通过对话进行的数据库操作',
        Cancel: '取消',
        Confirm: '确定',
        Number: '整数类型',
        Decimal: '小数类型',
        Text: '文本类型',
        Datetime: '日期类型',
        Longtext: '长文本',
        DeleteConfirm: '删除数据无法恢复,是否确定删除数据?',
        DeleteFile: '删除数据',
        Operation: '操作',
        OneClickImport: '一键导入',
        ImportTable: '导入表格',
        ImportTableTip: '上传excel 或 csv 表格，表格中列名需要和数据表字段一致',
        DownloadTemplate: '点击下载模板',
        ReUpload: '重新上传',
        UploadTip: '拖入文件 或 点击上传',
        FileImporting: '文件导入中，请耐心等待~',
        UploadFailed: '上传失败',
        PleaseUploadFile: '请先上传文件',
        ImportFailedFiveRecords: ', 导入失败{count}条数据',
        ImportSuccess: '导入成功{count}条数据',
        PleaseCreateDataTable: '请先创建数据表',
        ConfigureDataTable: '配置数据表',
        RemoteDatabaseTip: '远程连接您自己的数据库，可一键同步数据库的表和字段，实时检索最新数据。',
        PleaseContactCustomerService: {
            please: '请',
            contactCustomerService: '联系客服',
            toActivate: '开通使用权限',
        },
        PleaseDescribeYourDatabaseUsageScenario: '请详细描述您的数据库使用场景',
        SelectAll: '全选',
        NoData: '暂无数据',
        NextStep: '下一步',
        PleaseSelectAtLeastOnePermission: '请至少选择一个权限',
        CreateSuccess: '创建成功，可点击「一键导入」进行数据初始化，或选择「数据表配置」手动创建表',
        CreateDatabase: '创建数据库',
        DataPreview: '数据预览',
        TableConfig: '数据表配置',
        DatabaseConfig: '数据库配置',
        DataTables: '数据表',
        Create: '新建',
        FieldConfig: '字段配置',
        AddTableField: '新增表字段',
        DeleteTable: '删除数据表',
        FieldName: '字段名',
        PleaseEnterFieldName: '请输入字段名',
        FieldType: '字段类型',
        FieldDescription: '字段描述',
        FieldDescriptionTip: '字段描述将用于SQL语句的生成，请尽量清楚地描述该字段的含义',
        PleaseEnterFieldDescription: '请输入字段描述',
        AddRemoteTable: '添加远程表',
        AddTable: '新建数据表',
        TableImport: '表格导入',
        TableName: '数据表名称',
        PleaseEnterTableName: '请输入数据表名称',
        TableDescription: '数据表描述',
        TableDescriptionTip: '数据表描述将用于SQL语句的生成，请尽量清楚地描述该数据表中的数据内容和用途',
        PleaseEnterTableDescription: '请输入数据表描述',
        CurrentFile: '当前文件',
        fileType: {
            Integer: '整数',
            Decimal: '小数',
            Text: '文本',
            Datetime: '日期',
            Longtext: '长文本',
            LongtextTip: '长度超过 1000 字符的文本',
        },
        EditTableInfo: '修改数据表信息',
        TableImportTip: '上传excel 或 csv 表格，自动创建表结构并导入数据',
        FieldNameLabel: '字段名：',
        FieldTypeLabel: '字段类型：',
        FieldDescriptionLabel: '字段描述：',
        SelectFieldType: '请选择字段类型',
        PrimaryKeyID: '主键ID',
        DeleteTableConfirm: '删除将无法恢复此数据表，是否确认删除?',

        DeleteTableLoading: '数据表删除中，请稍后~',
        DeleteTableFieldLoading: '数据表字段删除中，请稍后~',
        DeleteTableFieldConfirm: '删除将无法恢复此数据表字段，是否确认删除?',
        DeleteTableField: '删除数据表字段',
        AddSuccess: '新增成功',
        BuiltInDatabaseTip: '直接创建数据库，可自定义表结构和字段，通过导入或手动添加的方式新增数据。',
    }
}